import { useTranslation } from 'react-i18next'

import { fmtDate } from '../../utils/fmtDate'
import styles from './StudentDrawer.module.scss'

const StudentDrawer = ({
  drawer,
  draftText,
  setDraftText,
  setDraftFiles,
  onClose,
  onSaveDraft,
  onSendForReview,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={styles.drawerOverlay} onClick={onClose}>
      <div className={`unv-card ${styles.drawer}`} onClick={(e) => e.stopPropagation()}>
        <div className={styles.drawerHeader}>
          <h2>{drawer.assignment?.title || t('assignments.task_default_title')}</h2>
          <button className="unv-btn unv-btn--ghost" onClick={onClose}>
            {t('assignments.close_btn')}
          </button>
        </div>

        <div className={styles.drawerBody}>
          <div className={styles.section}>
            <div className={styles.muted}>{t('assignments.description_label')}</div>
            <div>{drawer.assignment?.description || '—'}</div>
          </div>
          {drawer.assignment?.due_at && (
            <div className={styles.muted}>
              {t('assignments.deadline_label', { value: fmtDate(drawer.assignment.due_at) })}
            </div>
          )}
          {Array.isArray(drawer.assignment?.files) && drawer.assignment.files.length > 0 && (
            <div className={styles.section}>
              <div className={styles.muted}>{t('assignments.task_files')}</div>
              {drawer.assignment.files.map((f) => (
                <a
                  key={f.id || f.url}
                  className="unv-btn unv-btn--ghost"
                  href={f.url || f.file}
                  target="_blank"
                  rel="noreferrer"
                >
                  {f.name || t('assignments.file_default')}
                </a>
              ))}
            </div>
          )}

          {drawer.submission && (
            <div className={styles.muted}>
              {t('assignments.submission_status')}:{' '}
              <span className="unv-badge">{drawer.submission.status}</span>
              {drawer.submission.grade != null &&
                t('assignments.grade_inline', { value: drawer.submission.grade })}
            </div>
          )}

          <div className={styles.section}>
            <label>{t('assignments.answer_text')}</label>
            <textarea
              className="unv-input"
              rows="6"
              value={draftText}
              onChange={(e) => setDraftText(e.target.value)}
            />
          </div>
          <div className={styles.section}>
            <label>{t('assignments.files_label')}</label>
            <input
              type="file"
              multiple
              onChange={(e) => setDraftFiles(Array.from(e.target.files || []))}
            />
          </div>

          <div className={styles.drawerActions}>
            <button className="unv-btn unv-btn--ghost" onClick={onSaveDraft}>
              {t('assignments.save_draft_btn')}
            </button>
            <button className="unv-btn" onClick={onSendForReview}>
              {t('assignments.send_for_review_btn')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StudentDrawer
